import React from 'react';

import {find} from 'lodash';
import countriesByAbbreviation from './CountriesByAbbreviation';
import ReactCountryFlag from 'react-country-flag';
import CountryFlagAlias from './CountryFlagAlias';

const DEFAULT_FLAG_CLASS_NAME = 'flag-default';

export default function CountryFlag(props) {
    let { country, className } = props;
//    if(CountryFlagAlias.hasOwnProperty(country))
//        country = CountryFlagAlias[country];
    const styles = className || DEFAULT_FLAG_CLASS_NAME;
//    const countryStructure = countriesByAbbreviation.find(countryData => countryData.country === country ),
//        countryAbbreviation = countryStructure ? countryStructure.abbreviation : null;
    
    return country && country !== 'ZZ' ? <ReactCountryFlag svg countryCode={country} aria-label={country} className={styles} /> : null;
}

export function CountryFlagByAbbreviation(props) {
  const { country, className } = props;
  const styles = className || DEFAULT_FLAG_CLASS_NAME;

  return <ReactCountryFlag svg countryCode={country} className={styles} aria-label={country} />
}
